var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0402 1.45934C11.374 1.1256 11.374 0.584508 11.0402 0.25077C10.7065 -0.0829678 10.1654 -0.0829676 9.83167 0.25077L5.64453 4.43791L1.45739 0.250769C1.12365 -0.0829683 0.582555 -0.0829678 0.248817 0.25077C-0.0849209 0.584508 -0.0849208 1.1256 0.248817 1.45934L4.43596 5.64648L0.248816 9.83363C-0.0849215 10.1674 -0.0849211 10.7085 0.248817 11.0422C0.582555 11.3759 1.12365 11.3759 1.45739 11.0422L5.64453 6.85506L9.83167 11.0422C10.1654 11.3759 10.7065 11.3759 11.0402 11.0422C11.374 10.7085 11.374 10.1674 11.0402 9.83363L6.8531 5.64648L11.0402 1.45934Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearBtn);
export default __webpack_public_path__ + "static/media/clearBtn.e5237841e67028105baf943211c8ee07.svg";
export { ForwardRef as ReactComponent };